import React, { useContext } from 'react';
import {
    Hidden,
    Grid,
} from '@material-ui/core'

import RewardContext from '../../context/reward-context';
import useStyles from '../../styles/components/rewards/stylesRewardShop';
import { Coin } from '../shared/component';

const RewardRedemptionLog = () => {
    const { rewardContext } = useContext(RewardContext);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const classes = useStyles()

    const onLoadMore = () => setRowsPerPage(rowsPerPage + 10)

    return (
        <div style={{ width: '100%' }}>
            {rewardContext.rewardRedemptionLog.slice(0, rowsPerPage).map((rewardLog, index) => (
                <Grid
                    item xs={12}
                    container
                    justify="center"
                    alignItems="center"
                    classes={{ root: classes.rootGridVoucher }}
                    className={classes.rootGridVoucherLog}
                    key={index}
                >
                    <Grid
                        justify="center"
                        alignItems="center"
                        container
                        item xs={7}
                        spacing={1}
                    >
                        <Grid item xs={12} sm={5} classes={{ root: classes.rootGridCategory }} className={classes.containerDescriptionLog}>
                            {rewardLog.category}
                        </Grid>
                        <Grid item xs={12} sm={7} classes={{ root: classes.rootGridDescription }}>
                            {rewardLog.description}
                        </Grid>
                    </Grid>
                    <Grid item xs={3} classes={{ root: classes.rootGridCategory }}>
                        {rewardLog.date}
                    </Grid>
                    <Hidden smDown>
                        <Grid item xs={2} container justify="flex-end">
                            <Coin
                                coin={`${rewardLog.isEarned ? '+' : '-'}${rewardLog.coins}`}
                                size="medium"
                                color={rewardLog.isEarned ? 'plus' : 'substract'}
                            />
                        </Grid>
                    </Hidden>
                    <Hidden mdUp>
                        <Grid item xs={2} container justify="flex-end">
                            <Coin
                                coin={`${rewardLog.isEarned ? '+' : '-'}${rewardLog.coins}`}
                                size="small"
                                color={rewardLog.isEarned ? 'plus' : 'substract'}
                            />
                        </Grid>
                    </Hidden>
                </Grid>
            ))}

            {rewardContext.rewardRedemptionLog.length > rowsPerPage &&
                <Grid classes={{ root: classes.containerLoadmore }} container justify="center" alignItems="center" onClick={() => onLoadMore()}>
                    <div>
                        Load more
                    </div>
                </Grid>
            }
        </div>
    )
}

export { RewardRedemptionLog as default }